.nyxf2f0 {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  background-color: var(--_1qu8za2g);
  margin-bottom: 16px;
  padding: 24px;
  border: 1px solid var(--_1qu8za22);
  flex-direction: column;
}
.nyxf2f1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.nyxf2f2 {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za23);
  display: flex;
  align-items: center;
  gap: 8px;
}
.nyxf2f3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
}
.nyxf2f4 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za23);
}
.nyxf2f5 {
  margin-top: auto;
  width: fit-content;
}
.nyxf2f6 {
  position: relative;
  overflow: hidden;
  width: 100%;
}
.nyxf2f7 {
  width: 550px;
}
.nyxf2f8 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100px;
  background: linear-gradient(to right, transparent, var(--_1qu8za2g));
}
@media screen and (min-width: 768px) {
  .nyxf2f0 {
    flex-direction: row;
  }
  .nyxf2f1 {
    width: 50%;
  }
  .nyxf2f6 {
    width: 50%;
  }
}